import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import LoadingStates from "../constants/states/LoadingStates";
import SecureBaseStore from "./SecureBaseStore";


class ProfileState {
    constructor(
        loadingState,
        profileId,
        memberId,
        displayName,
        email,
        phoneNumber,
        about,
        paymentAddressName,
        currentPaymentAddressId,
        currentPaymentAddressGooglePlaceId,
        currentPaymentAddressStreetNumber,
        currentPaymentAddressRoute,
        currentPaymentAddressSecondaryAddress,
        currentPaymentAddressLocality,
        currentPaymentAddressAdministrativeAreaLevel1,
        currentPaymentAddressAdministrativeAreaLevel2,
        currentPaymentAddressCountryLong,
        currentPaymentAddressCountryShort,
        currentPaymentAddressPostalCode,
        currentPaymentAddressFormattedAddress,
        currentPaymentAddressLatitude,
        currentPaymentAddressLongitude,
        created,
        updated,
        deleted
    ) {
        this.loadingState = loadingState;
        this.profileId = profileId;
        this.memberId = memberId;
        this.displayName = displayName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.about = about;
        this.paymentAddressName = paymentAddressName;
        this.currentPaymentAddressId = currentPaymentAddressId;
        this.currentPaymentAddressGooglePlaceId = currentPaymentAddressGooglePlaceId;
        this.currentPaymentAddressStreetNumber = currentPaymentAddressStreetNumber;
        this.currentPaymentAddressRoute = currentPaymentAddressRoute;
        this.currentPaymentAddressSecondaryAddress = currentPaymentAddressSecondaryAddress;
        this.currentPaymentAddressLocality = currentPaymentAddressLocality;
        this.currentPaymentAddressAdministrativeAreaLevel1 = currentPaymentAddressAdministrativeAreaLevel1;
        this.currentPaymentAddressAdministrativeAreaLevel2 = currentPaymentAddressAdministrativeAreaLevel2;
        this.currentPaymentAddressCountryLong = currentPaymentAddressCountryLong;
        this.currentPaymentAddressCountryShort = currentPaymentAddressCountryShort;
        this.currentPaymentAddressPostalCode = currentPaymentAddressPostalCode;
        this.currentPaymentAddressFormattedAddress = currentPaymentAddressFormattedAddress;
        this.currentPaymentAddressLatitude = currentPaymentAddressLatitude;
        this.currentPaymentAddressLongitude = currentPaymentAddressLongitude;
        this.created = created;
        this.updated = updated;
        this.deleted = deleted;
    }

    equals(other) {
        return this.loadingState === other.loadingState &&
            this.profileId === other.profileId &&
            this.memberId === other.memberId &&
            this.displayName === other.displayName &&
            this.email === other.email &&
            this.phoneNumber === other.phoneNumber &&
            this.about === other.about &&
            this.paymentAddressName === other.paymentAddressName &&
            this.currentPaymentAddressId === other.currentPaymentAddressId &&
            this.currentPaymentAddressGooglePlaceId === other.currentPaymentAddressGooglePlaceId &&
            this.currentPaymentAddressStreetNumber === other.currentPaymentAddressStreetNumber &&
            this.currentPaymentAddressRoute === other.currentPaymentAddressRoute &&
            this.currentPaymentAddressSecondaryAddress === other.currentPaymentAddressSecondaryAddress &&
            this.currentPaymentAddressLocality === other.currentPaymentAddressLocality &&
            this.currentPaymentAddressAdministrativeAreaLevel1 === other.currentPaymentAddressAdministrativeAreaLevel1 &&
            this.currentPaymentAddressAdministrativeAreaLevel2 === other.currentPaymentAddressAdministrativeAreaLevel2 &&
            this.currentPaymentAddressCountryLong === other.currentPaymentAddressCountryLong &&
            this.currentPaymentAddressCountryShort === other.currentPaymentAddressCountryShort &&
            this.currentPaymentAddressPostalCode === other.currentPaymentAddressPostalCode &&
            this.currentPaymentAddressFormattedAddress === other.currentPaymentAddressFormattedAddress &&
            this.currentPaymentAddressLatitude === other.currentPaymentAddressLatitude &&
            this.currentPaymentAddressLongitude === other.currentPaymentAddressLongitude &&
            this.created === other.created &&
            this.updated === other.updated &&
            this.deleted === other.deleted;
    }
}

class ImmutableProfileStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.profileId = -1;
        this.memberId = -1;
        this.displayName = "";
        this.email = "";
        this.phoneNumber = "";
        this.about = "";
        this.paymentAddressName = "";
        this.currentPaymentAddressId = -1;
        this.currentPaymentAddressGooglePlaceId = -1;
        this.currentPaymentAddressStreetNumber = "";
        this.currentPaymentAddressRoute = "";
        this.currentPaymentAddressSecondaryAddress = "";
        this.currentPaymentAddressLocality = "";
        this.currentPaymentAddressAdministrativeAreaLevel1 = "";
        this.currentPaymentAddressAdministrativeAreaLevel2 = "";
        this.currentPaymentAddressCountryLong = "";
        this.currentPaymentAddressCountryShort = "";
        this.currentPaymentAddressPostalCode = "";
        this.currentPaymentAddressFormattedAddress = "";
        this.currentPaymentAddressLatitude = -1;
        this.currentPaymentAddressLongitude = -1;
        this.created = 0;
        this.updated = 0;
        this.deleted = true;
    }

    setProfileState(
        profileId,
        memberId,
        displayName,
        email,
        phoneNumber,
        about,
        paymentAddressName,
        currentPaymentAddressId,
        currentPaymentAddressGooglePlaceId,
        currentPaymentAddressStreetNumber,
        currentPaymentAddressRoute,
        currentPaymentAddressSecondaryAddress,
        currentPaymentAddressLocality,
        currentPaymentAddressAdministrativeAreaLevel1,
        currentPaymentAddressAdministrativeAreaLevel2,
        currentPaymentAddressCountryLong,
        currentPaymentAddressCountryShort,
        currentPaymentAddressPostalCode,
        currentPaymentAddressFormattedAddress,
        currentPaymentAddressLatitude,
        currentPaymentAddressLongitude,
        created,
        updated,
        deleted
    ) {
        this.loadingState = LoadingStates.FINISHED_LOADING;
        this.profileId = profileId;
        this.memberId = memberId;
        this.displayName = displayName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.about = about;
        this.paymentAddressName = paymentAddressName;
        this.currentPaymentAddressId = currentPaymentAddressId;
        this.currentPaymentAddressGooglePlaceId = currentPaymentAddressGooglePlaceId;
        this.currentPaymentAddressStreetNumber = currentPaymentAddressStreetNumber;
        this.currentPaymentAddressRoute = currentPaymentAddressRoute;
        this.currentPaymentAddressSecondaryAddress = currentPaymentAddressSecondaryAddress;
        this.currentPaymentAddressLocality = currentPaymentAddressLocality;
        this.currentPaymentAddressAdministrativeAreaLevel1 = currentPaymentAddressAdministrativeAreaLevel1;
        this.currentPaymentAddressAdministrativeAreaLevel2 = currentPaymentAddressAdministrativeAreaLevel2;
        this.currentPaymentAddressCountryLong = currentPaymentAddressCountryLong;
        this.currentPaymentAddressCountryShort = currentPaymentAddressCountryShort;
        this.currentPaymentAddressPostalCode = currentPaymentAddressPostalCode;
        this.currentPaymentAddressFormattedAddress = currentPaymentAddressFormattedAddress;
        this.currentPaymentAddressLatitude = currentPaymentAddressLatitude;
        this.currentPaymentAddressLongitude = currentPaymentAddressLongitude;
        this.created = created;
        this.updated = updated;
        this.deleted = deleted;
        return this;
    }

    build() {
        return Object.freeze(
            new ProfileState(
                this.loadingState,
                this.profileId,
                this.memberId,
                this.displayName,
                this.email,
                this.phoneNumber,
                this.about,
                this.paymentAddressName,
                this.currentPaymentAddressId,
                this.currentPaymentAddressGooglePlaceId,
                this.currentPaymentAddressStreetNumber,
                this.currentPaymentAddressRoute,
                this.currentPaymentAddressSecondaryAddress,
                this.currentPaymentAddressLocality,
                this.currentPaymentAddressAdministrativeAreaLevel1,
                this.currentPaymentAddressAdministrativeAreaLevel2,
                this.currentPaymentAddressCountryLong,
                this.currentPaymentAddressCountryShort,
                this.currentPaymentAddressPostalCode,
                this.currentPaymentAddressFormattedAddress,
                this.currentPaymentAddressLatitude,
                this.currentPaymentAddressLongitude,
                this.created,
                this.updated,
                this.deleted));
    }
}

class ProfileStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.PROFILE_STORE_UPDATED, ImmutableProfileStateBuilder);
        this.subscribeToEvent(ActionResultEvents.PROFILE_LOADED, this.handleProfileLoaded);
        this.subscribeToEvent(ActionResultEvents.PROFILE_EDITED, this.resetStore);
    }

    handleProfileLoaded = (topic, data) => {
        return new ImmutableProfileStateBuilder()
            .setProfileState(
                data.profileId,
                data.memberId,
                data.displayName,
                data.email,
                data.phoneNumber,
                data.about,
                data.paymentAddressName,
                data.currentPaymentAddressId,
                data.currentPaymentAddressGooglePlaceId,
                data.currentPaymentAddressStreetNumber,
                data.currentPaymentAddressRoute,
                data.currentPaymentAddressSecondaryAddress,
                data.currentPaymentAddressLocality,
                data.currentPaymentAddressAdministrativeAreaLevel1,
                data.currentPaymentAddressAdministrativeAreaLevel2,
                data.currentPaymentAddressCountryLong,
                data.currentPaymentAddressCountryShort,
                data.currentPaymentAddressPostalCode,
                data.currentPaymentAddressFormattedAddress,
                data.currentPaymentAddressLatitude,
                data.currentPaymentAddressLongitude,
                data.created,
                data.updated,
                data.deleted)
            .build();
    };
}

export default new ProfileStore();